import { createSlice } from '@reduxjs/toolkit'

import { SLICES } from '@/reducers/utils/constants'

import { extraReducers, reducers } from './reducers'

const initialState = {
  language: 'en',
  locale: 'en-US',
  localeParam: '',
}

const currentLocale = createSlice({
  extraReducers,
  initialState,
  name: SLICES.currentLocale,
  reducers
})

export const { actions } = currentLocale
export default currentLocale
